var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPolicyNumber(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 23,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7 23H2.84c-1.143 0-2-.953-2-2V2.9c0-1.143.952-2 2-2h8.478v4.572c0 1.048.857 1.81 1.81 1.81H17.7V21c0 1.047-.953 2-2 2zM2.84 2.043a.854.854 0 00-.858.857V21c0 .476.381.857.858.857H15.7a.854.854 0 00.857-.857V8.425h-3.43a2.968 2.968 0 01-2.953-2.953V2.043H2.84z",
    fill: "#ED1B2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.414 6.235h-4.287a.751.751 0 01-.762-.763V1.186l5.05 5.049zM13.508 5.09h1.144l-1.143-1.143v1.143zM3.697 11.76c0-.382.286-.667.667-.667h9.716c.381 0 .667.285.667.666a.651.651 0 01-.667.667H4.364a.651.651 0 01-.667-.667zM14.842 14.617a.651.651 0 00-.667-.667H4.364a.651.651 0 00-.667.667c0 .381.286.667.667.667h9.716c.476 0 .762-.286.762-.667zM14.842 17.666a.651.651 0 00-.667-.667H4.364a.651.651 0 00-.667.667c0 .38.286.666.667.666h9.716c.476 0 .762-.285.762-.666z",
    fill: "#ED1B2E"
  })));
}

export default SvgPolicyNumber;